import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const Spinner = (props) => {
  const { className, size } = props;
  return <div className={classNames("at-spinner-border", `at-spinner-border--${size}`, className)}></div>;
};
Spinner.propTypes = {
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  className: PropTypes.string,
};
Spinner.defaultProps = {
  size: "md",
  className: "",
};

const SpinnerOverlay = (props) => {
  const { show, className } = props;
  const [render, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  return (
    render && (
      <div
        className={classNames("at-spinner-overlay", className)}
        style={{
          animation: `${show ? "fadeIn 0.25s" : "fadeOut 0.5s"} `,
        }}
        onAnimationEnd={onAnimationEnd}
      >
        {show && <Spinner></Spinner>}
      </div>
    )
  );
};
SpinnerOverlay.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string,
};
SpinnerOverlay.defaultProps = {
  show: false,
};
export { Spinner, SpinnerOverlay };
